<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Temporary Businesses</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar">
	    	
	    	<v-list nopadding>
	    		
	    		<div v-for="(item, index) in items" :key="index">
	    			<v-list-tile>
	                    <v-list-tile-content>
	                        <v-list-tile-title>{{item.BusinessName}}</v-list-tile-title>
	                    </v-list-tile-content>

	                    <v-list-tile-action>

			            	<v-menu>
					    	 	<v-btn slot="activator" icon nomargin><v-icon>more_horiz</v-icon></v-btn>

							    <v-list nopadding>

							    	<v-list-tile @click="fn_toggleDataShare('switch', item)" v-if="!item.isActive">
							          <v-list-tile-title>Switch</v-list-tile-title>
							        </v-list-tile>

							        <v-divider></v-divider>

							        <v-list-tile @click="fn_toggleDataShare('remove', item, index)">
							          <v-list-tile-title>Remove</v-list-tile-title>
							        </v-list-tile>

							    </v-list>
						    </v-menu>
			            	
			            </v-list-tile-action>
	                </v-list-tile>

                    <v-divider v-if="items.length-1!=index"></v-divider>

	    		</div>

	    	</v-list>

	    	<div v-if="!items.length" class="display_msg">No Temporary Business!</div>
	    </div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
				items:[]
			}
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_getTempBusinesses : function(){
				let self = this;
				this.showLoading('Please wait...');
		        this.getData('AllTemporaryBusiness', null, 
		            {
		                onSuccess: function(response){
		                    console.log(response);
		                    self.items = JSON.parse(response);
		                    self.hideLoading();
		                }, 
		                onError: function(error){
		                    console.log(error);
		                    self.hideLoading();
		                    self.showToast('Something went wrong. Try again!.');
		                }
		            }
		        );
			},

			fn_toggleDataShare: function(type, item, index){
				let filterObj = {};
				filterObj.businessId = this.$root.CurrentBusiness.BusinessID;
				filterObj.IsTemporary = this.$root.CurrentBusiness.temporaryBusiness ? true : false;

				let toggleValue = false;
				let self = this;
	          	this.getFilterData("WatchForegroundService", JSON.stringify(toggleValue), filterObj,
	              	{
	                  	onSuccess: function(response){
	                    	console.log(response);
	                    	// self.showToast("Data sharing disabled");

	                    	if(type=='remove'){
	                    		self.fn_removeTemporaryBusiness(item, index);
	                    	}
	                    	else{
	                    		self.fn_switchBusiness(item);
	                    	}
	                  	}, 
	                  	onError: function(error){
	                      	console.log(error);
	                  	}
	              	}
	          	);
			},

			fn_switchBusiness: function(item){

		        let filterObject = {};
		        filterObject.oldBusinessId = this.$root.CurrentBusiness.BusinessID;
		        filterObject.newBusinessId = item.BusinessID;

				let self = this;
				this.getFilterData('SwitchTemporaryBusiness', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
		                    self.showToast("Switched to "+item.BusinessName+"");
		                    self.fn_reopenDB(response, true);
				        }, 
				        onError: function(error){
				          	console.log(error);
				          	self.fn_reopenDB();
				        }
					}
		        );
			},

			fn_removeTemporaryBusiness: function(item, index){

		        let filterObject = {};
		        filterObject.businessId = item.BusinessID;
		        filterObject.isActive = item.isActive;

				let self = this;
				this.getFilterData('RemoveTemporaryBusiness', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
		                    self.items.splice(index, 1);
		                    self.showToast("Business: "+item.BusinessName +" removed");
		                    self.fn_reopenDB(response);
				        }, 
				        onError: function(error){
				          	console.log(error);
				          	self.fn_reopenDB();
				        }
					}
		        );
		    },

			fn_reopenDB: function(businessid, goBack){
	            let self = this;
	            let bid = businessid && businessid != "null" ? businessid : this.$root.CurrentBusiness.BusinessID;
	            this.getData('ReopenDataBase', bid, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);

	                        if(businessid){
	                        	self.$root.fn_getBusiness(null, null, function(){
		                          	console.log("get data");
		                          	goBack ? self.fn_goBack() : '';
		                        });
	                        }
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                    }
	                }
	            );
	        },
		},

	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  		this.fn_getTempBusinesses();
	  	}
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/temporary_businesses/items.vue